<template>
  <div :class="{ header_container: isActive, header_containers: hasError }">
    <div class="header_inner">
      <!-- Logo -->
      <div class="header_logo" v-if="marketInfo && marketInfo.domain">
        <!-- 若用户设置LOGO -->
        <a
          v-if="marketInfo && marketInfo.logo"
          :href="`/marketplace`"
        >
          <img :src="marketInfo.logo" :alt="marketInfo.name" />
        </a>
        <!-- 用户没有设置Logo,给一默认值 -->
        <a v-else :href="`/marketplace`" class="navbar-brand">
          <img
            src="https://static.goodrain.com/images/rainstore/rainbond-icon-white.png"
          />RainStore
        </a>
      </div>
      <!-- Logo -->
      <div v-else class="header_logo">
        <a href="/index.html" class="navbar-brand">
          <img
            src="https://static.goodrain.com/images/rainstore/rainbond-icon-white.png"
          />RainStore
        </a>
      </div>
      <!-- 应用搜索 -->
      <div v-if="!marketClosed" class="header_search">
        <el-input
          v-model="searchQuery"
          placeholder="请输入关键词"
          class="search_input"
          @keyup.enter.native="handleSearchApp"
        ></el-input>
        <el-button class="search_btn" @click="handleSearchApp">
          搜索应用
        </el-button>
      </div>
      <!-- <div>
        <a href="">帮助中心</a>
      </div> -->
      <!-- 登录和注册 -->
      <div class="header_registerAndLogin">
        <a @click="handleLogins">登录</a>
        <a @click="handleRegister">注册</a>
      </div>
    </div>
  </div>
</template>

<script>
import logoImg from '@/assets/images/logo.png';
import Vue from 'vue';
const header = Vue.extend({
  name: 'NewStore',
  components: {},
  data() {
    return {
      logoImg,
      searchQuery: '' // 应用搜索查询参数
    };
  },
  props: {
    marketInfo: {
      type: Object,
      required: true
    },
    marketClosed: {
      type: Boolean,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 搜索应用键盘按下搜索应用
    handleSearchApp() {
      this.$emit('handleSearchApp', this.searchQuery);
    },
    // 登录
    handleLogins() {
      this.$router.push({
        name: 'login'
      });
    },
    // 注册
    handleRegister() {
      this.$router.push({
        name: 'register'
      });
    }
  }
});
export default header;
</script>

<style scoped lang="scss">
@import '../../styles/newStoreHeader';
</style>



// WEBPACK FOOTER //
// src/components/Header/newStore.vue